import React from "react";
import { Typography, Tooltip } from "@mui/material";

function formatCurrency(val: number | null): string {
  if (val === null || val === undefined) return "--";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(val);
}

export default function WACRange({
  low,
  high,
  basis,
}: {
  low: number | null;
  high: number | null;
  basis?: string | null;
}) {
  if (low === null && high === null) {
    return (
      <Typography variant="body2" color="text.secondary">
        Not projected
      </Typography>
    );
  }

  const content = (
    <Typography variant="body2" fontWeight={500}>
      {formatCurrency(low)} - {formatCurrency(high)}
    </Typography>
  );

  if (basis) {
    return <Tooltip title={basis}>{content}</Tooltip>;
  }

  return content;
}
